import React, { useState, useEffect } from 'react';
import { Input, Box, Button, Text, useClipboard } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import axios from 'axios';

const CustomizedTextComponent = () => {
  const [inputText, setInputText] = useState('');
  const [displayText, setDisplayText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { onCopy, hasCopied } = useClipboard(displayText);

  const handleInputChange = (event) => {
    setInputText(event.target.value);
  };

  const handleGenerateText = async () => {
    setIsLoading(true);
    
    try {
      const options = {
        method: 'GET',
        url: 'https://article-extractor-and-summarizer.p.rapidapi.com/summarize',
        params: {
          url: inputText, 
          length: '3'
        },
        headers: {
          'X-RapidAPI-Key': 'b61cc4d1abmsha3d5138bdb19adcp1f1c14jsn2be057e19bfc',
          'X-RapidAPI-Host': 'article-extractor-and-summarizer.p.rapidapi.com'
        }
      };
      
      const response = await axios.request(options);
      setDisplayText(response.data.summary);
    } catch (error) {
      console.error(error);
    }

    setIsLoading(false);
  };

  return (
    <Box p={4} mb={20}>
      <Input
        placeholder="Enter URL of article e.g https://time.com/6266679/musk-ai-open-letter/"
        value={inputText}
        onChange={handleInputChange}
        mb={4}
        mt={20}
      />
      <Button
        onClick={handleGenerateText}
        isLoading={isLoading}
        loadingText="Generating"
        style={{backgroundColor:"#38B2AC",color:"#fff"}}
        mb={10}
      >
        Summarize
      </Button>
      {displayText && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          mt={4}
        >
          <Text style={{color:"	#000",padding:"20px"}}>{displayText}</Text>
          <Button
            mt={4}
            onClick={onCopy}
            colorScheme={hasCopied ? 'green' : 'gray'}
          >
            {hasCopied ? 'Copied' : 'Copy to Clipboard'}
          </Button>
        </motion.div>
      )}
    </Box>
  );
};

export default CustomizedTextComponent;
